<template>
  <div class="pageSUN">
    <XR-head titleText="我的SUN" :rightShow="true"></XR-head>    
    <div class="total balance" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">SUN总额</p>
      <p class="money">{{SUNInfo.Coin.toFixed(4)}}</p>
    </div>
    <div class="total account-address" v-if="!loaded">
      <p class="title"></p>
      <p class="address" ref="sunText">{{SUNInfo.CoinAddress}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div>

    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/usercenter/SUNRecharge">
          <mu-list-item title="SUN充值">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/SUNWithdraw">
          <mu-list-item title="SUN提现">
            <mu-icon slot="left" value=":fa fa-withdraw"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/SUNStream">
          <mu-list-item title="SUN查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      SUNInfo:{
        Coin:0
      },
      siteConfig:{ MobileBgImage : '' }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getSUNInfo()
  },
  methods: {
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },  
    getSUNInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetSUNAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/SUNActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.SUNInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.SUNInfo.CoinAddress
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
}
}
</script>
<style>
.pageSUN .total{
  background: white;
  padding: 20px 20px;
}
.pageSUN .total.balance{
  overflow: hidden;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
}
.pageSUN .title{
  line-height: 24px;
  font-size: 14px;
}
.pageSUN .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageSUN .total.balance .title{
  color:white;
}
.pageSUN .total.balance .money{
  color:white;
}


.pageSUN .sub-nav{
  background: white;
  margin-top: 10px;
}

.pageSUN .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 10px 0 20px;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageSUN .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sun.vue